var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.013,
    height: 14,
    viewBox: "0 0 29.013 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookIcon",
    transform: "translate(-245.6 -337.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M245.6,368.786c.113-.639.233-1.278.337-1.918q.669-4.105,1.33-8.211.242-1.494.486-2.988a.464.464,0,0,1,.1-.241l2.388,14.724h-.379c-.954,0-1.908-.021-2.861.007a1.249,1.249,0,0,1-1.4-.919Z",
    transform: "translate(0 -16.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M309.049,353.518l-2.591-15.977c.108-.005.205-.015.3-.015h20.881a1.166,1.166,0,0,1,1.312,1.142q.69,4.3,1.394,8.6.4,2.458.8,4.917a1.112,1.112,0,0,1-1.115,1.326c-.652.011-1.3,0-1.955,0H309.049ZM318.9,344.4q-2.676,0-5.352,0a2.464,2.464,0,0,0-.506.044,1.1,1.1,0,0,0-.83,1.263,1.139,1.139,0,0,0,1.263.931q5.409,0,10.818,0a2.17,2.17,0,0,0,.394-.035,1.107,1.107,0,0,0,.1-2.146,2.124,2.124,0,0,0-.532-.057Q321.578,344.4,318.9,344.4Z",
    transform: "translate(-56.547)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/bookIcon.6b3b2bc90a11651bf2b7ab191391ef9e.svg";
export { ForwardRef as ReactComponent };